import { render, staticRenderFns } from "./indexDetail.vue?vue&type=template&id=8f6c4d9e&scoped=true"
import script from "./indexDetail.vue?vue&type=script&lang=js"
export * from "./indexDetail.vue?vue&type=script&lang=js"
import style0 from "./indexDetail.vue?vue&type=style&index=0&id=8f6c4d9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6c4d9e",
  null
  
)

export default component.exports